export const onClientEntry = () => {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevents the default mini-infobar or install prompt from showing
    e.preventDefault();
    return false;
  });
};

// Respect hash anchors: when navigating to a URL with a #hash,
// scroll to that element instead of letting Gatsby scroll to top.
export const shouldUpdateScroll = ({
  routerProps: { location },
}: {
  routerProps: { location: { hash: string } };
}) => {
  if (location.hash) {
    const id = location.hash.slice(1);
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
    return false;
  }
  return true;
};
